import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { purifier } from '../../../utils/dom';
import { cleanInternalLinks, camelCase } from '../../../utils/string';

const Button = ({ content, attrs = {}, isManyButtons = 1, isProductInPageNav = false, parentHasLink = false }) => {
	const variantClasses = ['button__content'];
	const style = {};

	if (isManyButtons > 1) variantClasses.push('button__multiple');
	if (isProductInPageNav) variantClasses.push('button__inPageNav');
	if (attrs.outline) variantClasses.push('button__outline');
	if (attrs.fullWidth) variantClasses.push('button__fullWidth');
	if (attrs.fontSize) variantClasses.push(`button__${attrs.fontSize}`);
	if (attrs.className) variantClasses.push(`button_${attrs.className}`);
	if (attrs.backgroundColor) style.backgroundColor = attrs.backgroundColor;
	if (attrs.borderRadius) style.borderRadius = attrs.borderRadius.join(' ');
	if (attrs.textColor) style.color = attrs.textColor;
	if (content?.attrs?.style && content.attrs.style.indexOf(':') !== -1) {
		content.attrs.style.split(';').forEach((p) => {
			const [key, value] = p.split(':');
			style[camelCase(key)] = value;
		});
	}

	if (!content.rawText) return null;

	let location = cleanInternalLinks(content?.attrs?.href);
	if (parentHasLink) location = false;

	return (
		<ButtonElement type="link" location={location} openNewTab={content.attrs.target === '_blank'} variantClasses={variantClasses} style={Object.keys(style).length > 0 ? style : null}>
			{
				location === '#filter' && (
					<svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26">
						<g fill="none" fillRule="evenodd" transform="translate(1 1)">
							<circle cx="8" cy="3" r="3" />
							<circle cx="19" cy="12" r="3" />
							<circle cx="12" cy="21" r="3" />
							<line x2="26" y1="3" y2="3" strokeWidth="2" />
							<line x2="26" y1="12" y2="12" strokeWidth="2" />
							<line x2="26" y1="21" y2="21" strokeWidth="2" />
						</g>
					</svg>
				)
			}
			<span dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
		</ButtonElement>
	);
};

export default hot(module)(Button);
